import * as accessor from "./nodeAccessor";
import * as nodeUtils from "./utils/nodeUtils";
import * as pathUtils from "./utils/pathUtils";
import * as typeUtils from "./utils/typeUtils";
import * as systemUtils from "./utils/systemUtils";
import * as uuidUtils from './utils/uuidUtils'

export const createFunction = (name = "") => {
  const node = accessor.createNode();
  const type = typeUtils.getTypeFunction();

  accessor.setID(node, pathUtils.getIdElement(name, type));
  accessor.setName(node, name);
  accessor.setType(node, type);

  set(node);

  return node;
};

export const createInputParameter = (idParent, name = "") => {
  const node = accessor.createNode();

  let type;

  if (idParent && (pathUtils.isRoot(idParent) || pathUtils.isParameterGlobal(idParent))) {
    type = typeUtils.getTypeParameterGlobal();
  } else {
    type = typeUtils.getTypeParameter();
  }

  accessor.setID(node, pathUtils.getIdElement(name, typeUtils.getTypeParameter(), idParent));
  accessor.setName(node, name);
  accessor.setType(node, type);

  set(node);

  return node;
};

export const createOutputParameter = (idParent, name = "", valueDefault = "") => {
  const node = accessor.createNode();
  const type = typeUtils.getTypeParameterOutput();

  accessor.setID(node, pathUtils.getIdElement(name, typeUtils.getTypeParameter(), idParent));
  accessor.setName(node, name);
  accessor.setType(node, type);
  accessor.setValueDefault(node, valueDefault);

  set(node);

  return node;
};

export const createLinkedParameter = (idParent, name = "", idTarget = null) => {
  const node = accessor.createNode();
  const type = typeUtils.getTypeParameterLinked();

  accessor.setID(node, pathUtils.getIdElement(name, typeUtils.getTypeParameter(), idParent));
  accessor.setName(node, name);
  accessor.setType(node, type);
  accessor.setIdTarget(node, idTarget);

  set(node);

  return node;
};

export const createChoice = (idParent, name = "", value = null) => {
  const _node = accessor.createNode();
  const _type = typeUtils.getTypeChoice();

  const _nameParsed = String(name);

  accessor.setID(_node, pathUtils.getIdElement(_nameParsed, _type, idParent));
  accessor.setName(_node, _nameParsed);
  accessor.setType(_node, _type);
  accessor.setValue(_node, value);

  set(_node);

  return _node;
};

export const createConditionAlias = (idParent, name = "", expression = "") => {
  return createCondition(idParent, name, typeUtils.getTypeConditionAlias(), expression);
};

export const createConditionConstraint = (idParent, name = "", expression = "") => {
  return createCondition(idParent, name, typeUtils.getTypeConditionConstraint(), expression);
};

export const createConditionAssignment = (idParent, name = "", expression = "") => {
  return createCondition(idParent, name, typeUtils.getTypeConditionAssignment(), expression);
};

const createCondition = (idParent, name, type, expression) => {
  const node = accessor.createNode();

  accessor.setID(node, pathUtils.getIdElement(name, typeUtils.getTypeCondition(), idParent));
  accessor.setName(node, name);
  accessor.setType(node, type);
  accessor.setExpression(node, expression);

  set(node);

  return node;
};

//------------------------------------------------------------------------

export const copy = (ref) => {
  const node = systemUtils.createDeepCopy(ref);

  const time = Date.now();

  set(node, time);
  nodeUtils.visitElements(node, (e) => set(e, time));

  return node;
};

//------------------------------------------------------------------------

const set = (node, time) => {
  const unix = time ?? Date.now();

  accessor.setUUID(node, uuidUtils.createUuid());
  accessor.setTimeCreate(node, unix);
  accessor.setTimeUpdate(node, unix);
};
